type style = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';

function hapticFeedbackStyle(style: style): void {
  const setHapticFeedback = JSON.parse(
    localStorage.getItem('setHapticFeedback') || 'true',
  );

  if (!setHapticFeedback) return;

  if (Telegram?.WebApp?.HapticFeedback) {
    Telegram.WebApp.HapticFeedback.impactOccurred(style);
  }
}

export { hapticFeedbackStyle };
